import $ from "jquery";
import axios from "axios";
import AOS from "aos";

import "@babel/polyfill";

import LazyLoad from "vanilla-lazyload/dist/lazyload";
import Router from "./util/Router";

import configureStore from './redux/configureStore';
import { inputChange } from './redux/modules/cart'

export const store = configureStore();

window.$ = $;
window.jQuery = $;
window.store = store;

window.LazyLoadManager = new LazyLoad({
  threshold: 300,
  load_delay: 150,
  elements_selector: "[data-lazy]"
});

const svg4everybody = require("svg4everybody");
svg4everybody();

require("./util/customEvents-polyfill");

AOS.init({ once: true, duration: 600, easing: "ease-out", disable: "mobile" });

axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

/** Populate Router instance with DOM routes */
const routes = new Router({
  common: () => import(/* webpackChunkName: "common" */ "./routes/common"),
  pageHome: () => import(/* webpackChunkName: "pageHome" */ "./routes/home"),
  pageSearch: () =>
    import(/* webpackChunkName: "pageSearch" */ "./routes/search"),
  pageCategory: () =>
    import(/* webpackChunkName: "pageCategory" */ "./routes/category"),
  pageProduct: () =>
    import(/* webpackChunkName: "pageProduct" */ "./routes/product"),
  pageRegister: () =>
    import(/* webpackChunkName: "pageRegister" */ "./routes/register"),
  pageAddress: () =>
    import(/* webpackChunkName: "pageAdress" */ "./routes/address"),
  pageCart: () => import(/* webpackChunkName: "pageCart" */ "./routes/cart"),
  pageOrderDelivery: () =>
    import(/* webpackChunkName: "pageOrderDelivery" */ "./routes/delivery"),
  pageFaq: () => import(/* webpackChunkName: "pageFaq" */ "./routes/faq"),
  pageContact: () =>
    import(/* webpackChunkName: "pageContact" */ "./routes/contact"),
  pageReservation: () =>
    import(/* webpackChunkName: "pageReservation" */ "./routes/reservation"),
  pageCookies: () =>
    import(/* webpackChunkName: "pageCookies" */ "./routes/page-cookies"),
  pageOrderDelivery: () =>
    import(
      /* webpackChunkName: "pageOrderDelivery" */ "./routes/orderDelivery"
    ),
  pageOrderInvoice: () =>
    import(/* webpackChunkName: "pageConcept" */ "./routes/orderInvoice"),
  pageOrderPayment: () =>
    import(/* webpackChunkName: "pageOrderPayment" */ "./routes/orderPayment")
});

// Load Events
document.addEventListener("DOMContentLoaded", () => routes.loadEvents());



// WEBPACK FOOTER //
// ./ressources/src/js/app.js